import React from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import configData from "../config.json"
import { useEffect } from "react"

export default function Principal() {
  useEffect(() => {
    sessionStorage.clear()
    localStorage.clear()
  }, [])

  return (
    <motion.main
      className="main__container"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: "100%", opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <section className="container-fluid">
        <div className="row">
          <div className="col px-0">
            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
              </div>

              <div className="carousel-inner">
                <section className="mobile">
                  <div className="carousel-item active">
                    <img src={`/resources/${configData.COMPANY}/01-Banner-online-general-1A.png`} className="d-block w-100" alt="..."></img>
                  </div>
                  <div className="carousel-item">
                    <img src={`/resources/${configData.COMPANY}/01-Banner-online-general-2A.png`} className="d-block w-100" alt="..."></img>
                  </div>
                  <div className="carousel-item">
                    <img src={`/resources/${configData.COMPANY}/01-Banner-online-general-3A.png`} className="d-block w-100" alt="..."></img>
                  </div>
                </section>

                <section className="d-md-none d-lg-none">
                  <div className="carousel-item active">
                    <img src={`/resources/${configData.COMPANY}/01-Banner-online-general-1A-mobile.png`} className="d-block w-100" alt="..."></img>
                  </div>
                  <div className="carousel-item">
                    <img src={`/resources/${configData.COMPANY}/01-Banner-online-general-2A-mobile.png`} className="d-block w-100" alt="..."></img>
                  </div>
                  <div className="carousel-item">
                    <img src={`/resources/${configData.COMPANY}/01-Banner-online-general-3A-mobile.png`} className="d-block w-100" alt="..."></img>
                  </div>
                </section>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
        <div className="row px-lg-5 mt-4">
          <div className="offset-lg-2 col-lg-8 col-sm-12">
            <img src={`/resources/${configData.COMPANY}/01-online-iconos-pasos.png`} alt="" className="img-fluid w-100" />
          </div>
        </div>
        <div className="row pt-5">
          <div className="col text-center bg-1 mt-1 mb-1">
            <h3>{configData.PrincipalPageText}</h3>
          </div>
        </div>
        <div className="row pt-5 pb-5">
          <div className="pt-2 offset-lg-2 col-lg-3 offset-sm-1 col-sm-10 text-center">
            <a className="btn btn-lg w-100 btn-red" href={configData.INFO_LINKS.CAMPUS}>Sí, ya estudié en {configData.UniversityName}</a>
          </div>
          <div className="pt-2 offset-lg-2 col-lg-3  offset-sm-1 col-sm-10 text-center">
            <Link className="btn btn-lg w-100 btn-yellow" to="/information">No</Link>
          </div>
        </div>
      </section>
    </motion.main>
  );
}